import React from "react";
import { component_tool,utils_tool } from '@/tool';

import { WizTableForm, WizClassifySelect } from "@/containers/common";
const abilityCheckItem = WizTableForm.Config.abilityCheckItem(this, { apiParams: { state: 1 ,categoryState:1} });
import moment from "moment";
import StudentAbiliytItemUpd from './studentAbiliytItemUpd'
let { WizModal, WizButton } = component_tool;
let {$$,checkStrLength} = utils_tool;
let ref;
/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */
let componentName = 'studentAbilityItem';
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
};
const columns = (data) => {
  let result =  [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: "能力评估星级",
      name: "abilityCheckItemId",
      searchItem: {
        diy:WizTableForm,
        ...abilityCheckItem,
        selectType:"radio",
        initialValue:[],
        initRows:[],
        rules: [{
          required: true,
          message: '请选择能力评估星级',
        }]
      },
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '姓名',
      name: 'name',
      searchItem: {
      }
    },
    {
      title: '账号',
      name: 'account',
      searchItem: {
      },
      tableItem: {
        width: 150
      }
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {
        width: 200
      }
    },
    {
      title: '证件号码',
      name: 'idCard',
      tableItem: {
        width: 200
      }
    },
    {
      title: '账号状态',
      name: 'accountState',
      dataIndex: 'accountState',
      dict: [
        {code: 0, codeName: "激活"},
        {code: 1, codeName: "禁用"}
      ],
      tableItem: {
        width: 100,
      }
    },
    {
      title: '账号状态',
      name: 'disabled',
      dataIndex: 'disabled',
      dict: [
        {code: 0, codeName: "激活"},
        {code: 1, codeName: "禁用"}
      ],
      searchItem: {
        type: "select"
      },
    },
    {
      title: "品牌",
      name: "orgName",
      tableItem: {
        width: 130
      },
    },
    {
      title: "岗位",
      name: "positionNameString",
      tableItem: { width: 250 },
    },
    {
      title: "能力考核项目",
      name: "checkCategoryName",
      tableItem: {
        width: 200
      },
    },
    {
      title: "能力评估星级",
      name: "checkItemName",
      tableItem: {
        width: 200
      },
    },
    {
      title: "考核品牌",
      name: "checkOrgName",
      tableItem: {
        width: 100
      },
    },
    {
      title: "考核岗位",
      name: "checkPositionNameString",
      tableItem: {
        width: 250
      },
    },
    {
      title: "评估时间",
      name: "checkTime",
      tableItem: {
        width: 150,
        render: (text) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: "导入时间",
      name: "createTime",
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      }
    },

  ]
  if(data['abilityItem'] !==undefined && data['abilityItem'] instanceof Array && data['abilityItem'].length>0){
  let childrenInfo = [];
  for (let index = 0; index < data['abilityItem'].length; index++) {
    const element = data['abilityItem'][index];
    childrenInfo.push({ title: element['name'], name: 'abilityItemId'+element['abilityItemId'],key: 'abilityItemId'+element['abilityItemId'], dataIndex: 'abilityItemId'+element['abilityItemId'], width: 100,tableItem: {} })
  }

  let abilityItem = {
    title: "能力项评分",
    name: "abilityItem",
    dataIndex: "abilityItem",
    tableItem: {
      children: childrenInfo
    }
  };
  result.push(abilityItem)
}
  return result;
};



const templateConfig = (data) => {
  const { self } = data;
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params:
      {
        columns: columns(self['props']),
        searchBarProps:
        {
          buttonSort: [ 'add','delete','import','export'],
          buttons:
            [
              {
                key: 'export',
                custom: true,
                params: { icon: 'export', children: '导出', type: 'export' },
                customOnClick: {
                  key: 'action',
                  params: {
                    apiKey: "export",
                    apiParams: {}
                  },
                  formatParams: (rows, record, filters, callback) => {
                    if(!filters.abilityCheckItemId){
                      wizNotice.warn("请先选择能力评估星级")
                        return null;
                    }
                    return { ...filters }
                  }
                }
              },
              {
                key: "delete",
                custom: true,
                needSelect: true,
                params: {icon: "delete", children: "删除", type: "danger"},
                customOnClick: {
                  key: "action",
                  params: {
                    apiKey: "delete",
                    apiParams: {}
                  },
                  formatParams: (rows, record, filters, callback) => {
                    if (!rows) return;
                    if ($$.isArray(rows) && !rows.length) return;
                    const content = `删除后数据不可恢复，您确定要删除这${
                      $$.isArray(rows) ? rows.length : ""
                    }条学员能力评估星级数据吗？`;
                    let ids = [];
                    rows.forEach(e => {
                      if (e['rowKey']){
                        ids.push(e['rowKey']);
                      }
                    });
                    WizModal.confirm({
                      title: '注意', content,
                      onOk: () => {
                        callback && callback({
                          ids
                        })
                      },
                      onCancel() {
                      }
                    });
                    return null
                  }
                }
              },
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/train/studentAbilityList/studentAbilityItemDetailAdd'
              }
            }
          },
          {
            key: 'import',
            custom: true,
            params: { icon: 'import', children: '导入', type: 'import'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/train/studentAbilityList/studentAbilityFileImport',
              }
            },
          }
            ]
        },
        rowOperateSort: ['look', 'update'],//英文
        rowOperateView:
          [
            {
              key: 'update',
              custom: true,
              params: { children: '编辑'},
              customOnClick: {
                key: "modal",
                params: {
                  modalKey:new Date().getTime(),
                  modalParams: {
                    title: "编辑",
                    diy: (e) => {
                      e.record = Object.assign({},e.record)
                      return(
                        <StudentAbiliytItemUpd
                          {...e}
                          key={'StudentAbiliytItemUpd'+e.record.id+new Date().getTime()}
                         //initRows={initRows}
                          ref={r => {
                            ref = r && r.getWrappedInstance();
                          }}
                          timeStamp={new Date().getTime()}
                          alone={true}
                        />
                      )
                    },
                    onOk: () => {
                      ref._ok();
                    },
                    onCancel: () => {

                    },
                    width: 600
                  }
                },
                formatParams: (rows, record, filter) => {
                  return { ...record };
                }
              }
            },
            {
              key: 'look',
              custom: true,
              params: { children: '查看'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/train/abilityAssess'
                }
              }
            },
          ],
        modalFormProps:{

        },
        dataTableProps: {
          rowKey: 'id',
          selectType:
            'checkbox',
          isScroll:
            true,
          loading:
            false
        },
      }
    }
  }
};
let reduxTemplateConfig = (args) => {
  const apis = {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {}
      },
      autoInit:true
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {}
      }
    },
    publish: {
      path: `${componentName}/publish`,
      payload: {
        key: `${componentName}@publish`,
        apiParams: {}
      }
    },
    close: {
      path: `${componentName}/close`,
      payload: {
        key: `${componentName}@close`,
        apiParams: {}
      }
    },
  }

  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
